import { createSelector } from "reselect";
import * as api from "@/api/division-manager";

// constants

const prefix = "division-manager/division/role";

const FETCH_STARTED = `${prefix}/FETCH_STARTED`;
const FETCH_FAIL = `${prefix}/FETCH_FAIL`;
const FETCH_SUCCESS = `${prefix}/FETCH_SUCCESS`;

// actions
const fetchStart = () => ({ type: FETCH_STARTED, payload: true });
const fetchSuccess = (data) => ({ type: FETCH_SUCCESS, payload: data });
const fetchFail = (err) => ({ type: FETCH_FAIL, error: true, payload: err });

export function fetchDivisionRoleDetails(divisionId, roleId) {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const data = await api.fetchDivisionRole(divisionId, roleId);
      dispatch(fetchSuccess(data));
    } catch (err) {
      dispatch(fetchFail(err));
    }
  };
}

// selectors
const baseSelector = (state) => state.divisionManager.divisionRoleDetails;
export const getIsDivisionRoleDetailsFetching = createSelector(baseSelector, (state) => state.isFetching);
export const getDivisionRoleDetails = createSelector(baseSelector, (state) => state.record);

// state

const initialState = {
  record: null,
  error: false,
  isFetching: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_STARTED:
      return {
        ...state,
        isFetching: true,
      };

    case FETCH_SUCCESS:
      return {
        ...state,
        record: action.payload,
        isFetching: false,
        error: null,
      };

    case FETCH_FAIL:
      return {
        ...state,
        record: null,
        isFetching: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
